import { BackgroundVariant, Background } from "@xyflow/react";

export function CanvasBackground() {
  return <Background gap={10} variant={BackgroundVariant.Dots} />;
}
